import React, { useCallback, useEffect, useState } from 'react';
import { Popup } from "components/popups/Popup";
import Button from "components/shared/button";

import useTranslation from "utils/hooks/useTranslation";
import type { HpChoiceForm } from 'store/hpChoiceSlice';

interface TitleText {
    title: string;
    text: string;
}

export const DimensionmentPopup: React.FC<{
    closePopup: any;
    projectHpChoice: HpChoiceForm
}> = ({
    closePopup,
    projectHpChoice
}) => {
        const { t } = useTranslation();

        const [titleText, setTitleText] = useState<TitleText>({
            title: "",
            text: ""
        });

        useEffect(() => {
            switch (projectHpChoice?.heatPumpType) {
                case '1':
                    if (projectHpChoice?.releveChaudiere === 'chaudiere') {
                        setTitleText({ title: t("HELP_HPAWWBOILER_TITLE"), text: t("HELP_HPAWWBOILER_DESC") });
                        break;
                    }
                    setTitleText({ title: t("HELP_HPAW_TITLE"), text: t("HELP_HPAW_DESC") });
                    break;
                case '2':
                    if (projectHpChoice?.releveChaudiere === 'chaudiere') {
                        setTitleText({ title: t("help_hpwwboiler_title"), text: t("help_hpwwboiler_desc") });
                        break;
                    }
                    setTitleText({ title: t("HELP_HPWW_TITLE"), text: t("HELP_HPWW_DESC") });
                    break;
                case '3':
                    setTitleText({ title: t("HELP_HPHY_TITLE"), text: t("HELP_HPHY_DESC") });
                    break;
                default:
                    break;
            }
        }, [projectHpChoice])

        return (
            <Popup
                title={titleText.title}
                wrapTitle={true}
                translateTitle
                fixSize={"medium"}
                commandPanelProps={{
                    additionalElement: (
                        <group data-justify="start" data-gap="20">
                            <Button
                                data-length="forcefit"
                                secondary
                                large
                                onClick={() => {
                                    closePopup();
                                }}
                            >
                                {t("CLOSE")}
                            </Button>
                        </group>
                    )
                }}
            >
                <group
                    data-direction="column"
                    data-gap="20"
                    data-space="40"
                    data-space-horizontal="40"
                    data-space-top="5"
                    data-height="autofit"
                >
                    <group data-gap="20" data-custom="">
                        {/* {titleText.text} */}
                        <div dangerouslySetInnerHTML={{ __html: titleText.text }} />
                    </group>
                </group>
            </Popup>
        )
    };